import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-presenter-config-sidebar',
  imports: [],
  templateUrl: './gb-presenter-config-sidebar.component.html',
  styleUrl: './gb-presenter-config-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterConfigSidebarComponent {}
